import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import { CheckCircleIcon } from 'components/TripCard/styles';

export const Container = styled.div<Props>`
  display: flex;
  align-items: center;
  width: 30%;
  height: 100px;
  border-radius: 16px;
  box-shadow: 0 2px 16px 0 rgba(${ColorPalette.RGB.Black}, 0.1);
  background-image: ${(props: Props) => `linear-gradient(123deg, ${props.initialColor}, ${props.finalColor})`};
  padding: 10px;
  margin: 10px;

  &:hover {
    border: 2px solid ${({ theme }) => theme.primaryBackgroundColor};
    cursor: pointer;
  }

  @media ${({ theme }) => theme.device.mobile} {
    width: 80%;
  }
`;

export const Title = styled.h2`
  display: flex;
  align-items: center;
  flex-direction: column;
  font-weight: 600;
  font-size: 40px;

  color: ${({ theme }) => theme.group.section.title};
  justify-content: space-between;
  line-height: 1.4em;

  @media ${({ theme }) => theme.device.desktop} {
    margin: 30px 0 60px 0;
  }
`;

export const TitleContent = styled.span`
  display: flex;
  align-items: center;
  flex-direction: column;
  font-weight: 500;
  font-size: 30px !important;
  margin: 0px auto;
  vertical-align: middle;
  color: ${({ theme }) => theme.group.section.title};
  justify-content: space-between;
  line-height: 1.4em;

  @media ${({ theme }) => theme.device.desktop} {
    margin: 30px 0;
  }
`;

export const TitleSubContent = styled.span`
  font-family: Poppins;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
`;

export const ImageContainer = styled.div`
  height: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  & img {
    height: 100%;
    width: 100%;
    margin: 10px;
  }
`;
export const ImageType = styled.img`
  height: 80%;
`;

interface Props {
  initialColor: string;
  finalColor: string;
}

export const List = styled.ol`
  display: flex;

  @media ${({ theme }) => theme.device.mobile} {
    flex-direction: column;
    align-items: center;
  }

  @media ${({ theme }) => theme.device.desktop} {
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
`;

export const StatusText = styled.span`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  margin-left: auto;
  font-size: 10px;
  line-height: 1.6;
  color: ${ColorPalette.HEX.GreenPantone};

  & ${CheckCircleIcon} {
    width: 10px;
    height: 10px;
    margin-right: 4px;
    color: ${ColorPalette.HEX.GreenPantone};
  }
`;
